document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('CartCompanyCheckbox');
  const fields = document.getElementById('CartCompanyFields');
  if (!checkbox || !fields) return;

  checkbox.addEventListener('change', function () {
    fields.hidden = !checkbox.checked;
    if (!checkbox.checked) {
      document.getElementById('CartCompanyName').value = '';
      document.getElementById('CartCompanyRUT').value = '';
    }
  });
});